import RichText from '~/src/common/components/CMS/RichText';
import { ReadMore } from '~/src/common/components/ReadMore/ReadMore';
import Sticker from '~/src/common/components/Sticker';
import { type Category } from '~/src/common/typings/category';
import { sanitize } from '~/src/common/utils/text';

import Products from '../Products/Products';
import EmptyLarge from '../States/Empty/Large';
import Subcategory from '../Subcategory/Subcategory';

import * as S from './layout';

type Props = {
  category: Category;
};

const Category = ({ category }: Props) => {
  const nonEmptySubcategories = category.subcategories.filter(sc => sc.itemCount > 0);
  const showSubcategories = nonEmptySubcategories.length > 0;
  const showProducts = !showSubcategories && category.items.length > 0;
  const showEmpty = !showSubcategories && !showProducts;

  // Pour toutes les catégories, le footer reste collapse, seule les deux catégories
  // `fruits` et `legumes` font partie de l'expérience SEO et seront ouvert par défaut
  // S'agissant d'un test temporaire, on peut se permettre de mettre les valeurs en dur
  const isFooterCollapsed = category.slug !== 'fruits' && category.slug !== 'legumes';

  return (
    <S.Container data-observer={category.id}>
      <header>
        <h1>{category.title}</h1>
        {category.label ? (
          <Sticker fg={category.label.fg} bg={category.label.bg}>
            {category.label.text}
          </Sticker>
        ) : null}
      </header>

      {sanitize(category.header ?? '') ? (
        <summary>
          <RichText html={category.header} />
        </summary>
      ) : null}

      {showEmpty ? <EmptyLarge /> : null}

      {showProducts ? <Products category={category} /> : null}

      {showSubcategories ? (
        <S.Content>
          {category.subcategories.map(sub => (
            <Subcategory key={sub.id} subcategory={sub} />
          ))}
        </S.Content>
      ) : null}

      {sanitize(category.footer ?? '') ? (
        <footer>
          <S.Waves />
          <ReadMore key={category.slug} initialCollapsed={isFooterCollapsed}>
            <RichText html={category.footer} />
          </ReadMore>
        </footer>
      ) : null}
    </S.Container>
  );
};

export default Category;
